import logo from './logo.svg';
import './App.css';
import Header from './Header';
import CreateProposalForm from './CreateProposalForm';

function App() {
  return (
    <div>
      <Header />
      <CreateProposalForm />
    </div>
  );
}

export default App;
